import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const SHOW_OFFSET = 320;

class BackToTop extends PureComponent {
    state = {
        visible: false,
    };

    componentDidMount() {
        if (typeof window === 'undefined') return;

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.handleScroll();
    }

    componentWillUnmount() {
        if (typeof window === 'undefined') return;

        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        const visible = window.pageYOffset > SHOW_OFFSET;

        if (visible !== this.state.visible) {
            this.setState({ visible });
        }
    };

    handleClick = () => {
        if (typeof window === 'undefined') return;

        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    render() {
        const { visible } = this.state;

        return (
            <button
                type="button"
                className={`${styles.backTop}${visible ? ` ${styles.visible}` : ''}`}
                aria-label="返回顶部"
                onClick={this.handleClick}>
                <svg className={styles.icon} viewBox="0 0 16 16" aria-hidden="true">
                    <path d="M8 3.5 3 9h3v3.5h4V9h3L8 3.5z" fill="currentColor" />
                </svg>
            </button>
        );
    }
}

export default errorBoundary(BackToTop);
